import { render, staticRenderFns } from "./GerenciadorRelatorios.vue?vue&type=template&id=27009c66&scoped=true"
import script from "./GerenciadorRelatorios.vue?vue&type=script&lang=js"
export * from "./GerenciadorRelatorios.vue?vue&type=script&lang=js"
import style0 from "./GerenciadorRelatorios.vue?vue&type=style&index=0&id=27009c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27009c66",
  null
  
)

export default component.exports